/**
 * New and unregistered vehicles have no registration, so fall back to a
 * placeholder rather than reading through a null relation. A missing
 * formatted_vrm falls back to the raw vrm.
 */
export const vrm = (vehicle, field = 'formatted_vrm', placeholder = 'No Reg') => {
    return vehicle?.registration?.[field] || vehicle?.registration?.vrm || placeholder;
};
